import React, { createContext, useContext, useState, useEffect } from "react";
import { api } from "../lib/api";

const SiteContext = createContext();
export const useSite = () => useContext(SiteContext);

export const SiteProvider = ({ children }) => {
  const [site, setSite] = useState(null);
  useEffect(() => {
    api.get("/site").then((r) => setSite(r.data)).catch(() => setSite({}));
  }, []);
  return <SiteContext.Provider value={site || {}}>{children}</SiteContext.Provider>;
};
